import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ThemeAssetComponent } from '@partners/themes';
import { PanelComponent } from '../panel/panel.component';

@Component({
  selector: 'message-panel',
  standalone: true,
  imports: [ThemeAssetComponent, PanelComponent],
  template: `
  <panel>
      <theme-asset panel-prefix
       class="icon icon--xs"
       asset="info-icon-stroked"
       data-alt="אייקון מידע עגול"
       />
      <ng-content panel-body />
  </panel>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'message-panel'
  }
})
export class MessagePanelComponent {}
